<template>
  <div class="vip" v-if="hasUserInfo">
    <div class="content">
      <div class="banner">
        <div class="userinfo">
          <img :src="avatar" />
          <div>
            <div class="nickname">{{ name }}</div>
            <div class="desc">
              {{
                enterprise_vip
                  ? "企业版本：全部功能/参与人数：无限制"
                  : "基础版本：使用免费功能/参与人数：1000"
              }}
            </div>
          </div>
        </div>
        <div class="handle">
          <div class="date" v-if="enterprise_vip">
            {{ enterprise_vip_start || "" }}至{{ enterprise_vip_end || "" }}
          </div>
          <span class="handle-btn" @click="pay" v-if="!enterprise_vip"
            >升级权限</span
          >
          <span class="handle-btn" @click="pay" v-else>续费权限</span>
        </div>
      </div>
      <div class="main">
        <div class="productList">
          <div
            :class="
              productIndex == index ? 'active product-item ' : 'product-item '
            "
            v-for="(item, index) in productList"
            :key="item.key"
            @click="changeProduct(index)"
          >
            <div>
              <div class="name">{{ item.name }}</div>
              <div class="price">¥{{ item.price }}</div>
              <div class="discount">{{ item.discount }}</div>
              <div class="info" v-if="item.info">{{ item.info }}</div>
              <img
                v-if="productIndex == index"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/447a645f8ccf856b2edf9db4d16923a0.svg"
              />
            </div>
          </div>
        </div>
        <div class="buy-tips">
          <p>说明：（可开发票）</p>
          <p>
            购买企业版权限后，该账号创建的所有答题在付费期间，均可使用全部功能高级权限。
          </p>
          <p>使用中遇到任何问题，都可以联系专属客服咨询。</p>
        </div>
        <div class="vip-intro flexCenter">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/ac050edbf881e33f4fc8e1eb40ea8856.svg"
            alt=""
          />企业版权限介绍
        </div>
        <div class="vip-table">
          <div
            v-for="(item, index) in goodsInfo"
            :key="index"
            class="table-item"
          >
            <p
              v-for="(citem, cindex) in item"
              :key="cindex"
              :class="cindex == 0 ? 'flexCenter' : ''"
            >
              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/954ca578ba88e568b494c49c0d90082d.svg"
                alt=""
                v-if="index == 0 && cindex == 0"
              />
              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/bd5637482ca652975625d02f63a6c1a0.svg"
                alt=""
                v-if="index == 8 && cindex == 0"
              />

              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/853b43e72d41891985b723f56149ed47.svg"
                alt=""
                v-if="index == 12 && cindex == 0"
              />

              {{ citem }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="buy-btn" @click="pay">
      立即购买¥{{ productList[productIndex].price }}
    </div>
    <div class="mask-box" v-if="showModal">
      <div class="mask-content">
        <div class="confirm-bd">
          {{ buyInfo }} <br />
          到期时间: {{ b_time }}
        </div>
        <div class="confirm-footer">
          <div class="confirm-cancel" @click="closeConfirm">我知道了</div>
          <div class="confirm-ok" click="confirmOk">
            <wx-open-launch-weapp
              username="gh_f208968c610c"
              @launch="handleLaunchFn"
              @error="handleErrorFn"
              appid="wxee55405953922c86"
              :path="path"
            >
              <script type="text/wxtag-template">
                <div style="color: #12b7f5; height: 50px; line-height: 50px">前往小程序</div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { jumpWxAuth, getToken, formatDateTime } from "@/utils/common";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";

export default {
  data() {
    return {
      enterprise_vip: 0,
      enterprise_vip_start: "",
      enterprise_vip_end: "",
      buyInfo: "",
      showModal: false,
      path: "/pages/createdefault/createdefault",
      name: "",
      avatar: "",
      productIndex: 0,
      b_time: "",
      productList: [
        {
          name: "1周特权",
          price: 69,
          discount: "",
          key: 0,
          days: 7
        },
        {
          name: "1个月特权",
          price: 99,
          discount: "原价: 276",
          key: 1,
          days: 30,
          info: "立减177元"
        },
        {
          name: "12个月特权",
          price: 699,
          discount: "原价: 3312",
          key: 2,
          days: 365,
          info: "立减2613元"
        }
      ],
      hasUserInfo: false,
      goodsInfo: [
        ["基础功能", "免费版", "付费版"],
        ["参与人数限制", "1000人", "无限制"],
        ["同时在线人数限制", "1000人", "无限制"],
        ["头像/昵称自定义", "同步微信", "自定义"],
        ["排行榜展示人数", "1000（固定）", "自定义"],
        ["题目支持视频", "X", "✓"],
        ["极速审核", "X", "✓"],
        ["隐藏得分", "X", "✓"],
        ["数据下载", "免费版", "付费版"],
        ["题目错误率", "X", "✓"],
        ["答题内容（excel）", "X", "✓"],
        ["答题内容（word）", "单次：10条", "批量下载"],
        ["防作弊", "免费版", "付费版"],
        ["防切屏/截屏", "X", "✓"],
        ["禁止录屏", "X", "✓"]
      ]
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  methods: {
    closeConfirm() {
      this.showModal = false;
    },
    handleLaunchFn() {},
    handleErrorFn() {},
    // 价格切换
    changeProduct(e) {
      this.productIndex = e;
    },
    //获取用户信息
    handleUserInfo(refresh) {
      let param = { access_token: getToken() };
      if (refresh) {
        param.refresh = 1;
      }
      questionOnly.get(api.question.getServiceDetail, param).then(res => {
        if (res.sta == 0) {
          let {
            name,
            avatar,
            enterprise_vip,
            enterprise_vip_start,
            enterprise_vip_end
          } = res.data;
          this.hasUserInfo = true;
          this.name = name;
          this.avatar = avatar;
          this.enterprise_vip_start = formatDateTime(
            enterprise_vip_start * 1000,
            3
          );
          this.enterprise_vip_end = formatDateTime(
            enterprise_vip_end * 1000,
            3
          );
          this.enterprise_vip = enterprise_vip;
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },
    // 支付
    pay() {
      let param = {
        access_token: getToken(),
        type: "enterprise_vip",
        source: "h5",
        duration: this.productList[this.productIndex].days
      };
      questionOnly.post(api.question.bookVipBuy, param).then(res => {
        if (res.sta == 0) {
          this.callWxPay(res.data)
        } else {
          Toast(res.msg);
        }
      });
    },
    callWxPay(data) {
      let self = this;
      let enterprise_vip = self.enterprise_vip;
      let duration = self.productList[self.productIndex].days;
      let b_end = "";
      if (enterprise_vip) {
        b_end =
          new Date(self.enterprise_vip_end).getTime() + duration * 86400000;
      } else {
        b_end = new Date().getTime() + duration * 86400000;
      }
      b_end = formatDateTime(b_end, 3);
      let buyInfo = enterprise_vip ? "续费成功！" : "购买成功！";
      function onBridgeReady() {
        // @ts-ignore
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          { ...data, timeStamp: String(data.timeStamp) },
          function (res) {
            if (
              res.err_msg != "get_brand_wcpay_request:cancel" &&
              res.err_msg != "get_brand_wcpay_request:fail" &&
              res.errMsg !=
                "chooseWXPay:fail, the permission value is offline verifying" &&
              res.errMsg != "chooseWXPay:没有此SDK或暂不支持此SDK模拟"
            ) {
              Toast(JSON.stringify(res));
              // 支付成功
              // self.showModal = true;
              // self.b_time = b_end;
              // self.buyInfo = buyInfo;
              // self.handleUserInfo("refresh");
            } else {
              // 支付失败
              Toast(res.errMsg);
            }
          }
        );
      }
      // @ts-ignore
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
  }

  },
  mounted() {
    if (!getToken()) {
      jumpWxAuth().then(() => {
        this.handleUserInfo();
      });
    } else {
      this.handleUserInfo();
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}

.vip {
  background: #ffffff;
}
.banner {
  background: linear-gradient(180deg, #12b7f5 0%, #007aff 100%);
  height: rem(260);
  box-sizing: border-box;
  border-radius: rem(12);
  background-size: 100% 100%;
  margin-bottom: rem(30);
  padding: rem(30) rem(50) rem(30) rem(30);
  color: #ffffff;
}

.userinfo {
  display: flex;
  align-items: center;
}

.userinfo img {
  width: rem(62);
  height: rem(62);
  border-radius: 50%;
  margin-right: rem(10);
  border: rem(4) solid #ffffff;
}

.nickname {
  font-weight: 800;
  font-size: rem(30);
  line-height: rem(45);
}
.handle {
  position: relative;
  font-size: rem(24);
  line-height: rem(36);
  padding-top: rem(80);
}

.handle .handle-btn {
  width: rem(200);
  text-align: center;
  height: rem(60);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: rem(40);
  font-size: rem(30);
  top: 30px;
  color: #000000;
}
.desc {
  font-size: rem(24);
  line-height: rem(36);
}

.content {
  background: white;
  padding: rem(30) rem(30) rem(140);
}

.productList {
  margin-top: rem(30);
  display: flex;
  justify-content: space-between;
}

.product-item {
  background: #ffffff;
  border-radius: rem(8);
  width: rem(203);
  height: rem(260);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  border: rem(4) solid transparent;
  box-shadow: 0 rem(1) rem(16) rgba(0, 0, 0, 0.08);
  .info {
    position: absolute;
    left: rem(-2);
    top: rem(-2);
    background: #1890ff;
    // background: linear-gradient(90deg, #ffc083 0%, #ff7d00 100%);
    border-radius: rem(8) 0 rem(30);
    font-size: rem(24);
    width: rem(158);
    text-align: center;
    color: #ffffff;
    line-height: rem(36);
  }
}
.product-item.active {
  border: rem(4) solid #1890ff;
}
.productList .product-item:nth-child(2),
.productList .product-item:nth-child(3) {
  padding-top: rem(34);
}
.product-item img {
  width: rem(56);
  height: rem(56);
  position: absolute;
  right: rem(-4);
  bottom: rem(-4);
}

.name {
  font-size: rem(28);
  line-height: rem(28);
  color: #262626;
}

.price {
  font-weight: 900;
  font-size: rem(40);
  line-height: rem(60);
  color: #1890ff;
  margin-top: rem(4);
}

.discount {
  font-size: rem(24);
  line-height: rem(36);
  text-decoration-line: line-through;
  color: #999999;
}
.buy-btn {
  position: fixed;
  z-index: 3;
  left: rem(30);
  right: rem(30);
  bottom: rem(28);
  height: rem(90);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  border-radius: rem(8);
  color: #ffffff;
  font-weight: 700;
  font-size: rem(32);
}
.buy-tips {
  font-size: rem(24);
  line-height: rem(32);
  color: #999999;
  background: #f2f2f7;
  border-radius: rem(8);
  padding: rem(20);
  margin-top: rem(30);
}
.vip-intro {
  font-weight: 700;
  font-size: rem(34);
  line-height: rem(40);
  color: #000000;
  margin: rem(60) 0 rem(20);
  img {
    width: rem(30);
    height: rem(34);
    margin-right: rem(20);
  }
}
.vip-table {
  border: rem(2) solid #f2f2f7;
  border-radius: rem(8);
}
.vip-table img {
  width: rem(48);
  height: rem(48);
  margin-right: rem(15);
}
.table-item {
  display: flex;
  align-items: center;
  padding: rem(34) rem(30);
}

.table-item:nth-child(2),
.table-item:nth-child(4),
.table-item:nth-child(6),
.table-item:nth-child(8),
.table-item:nth-child(10),
.table-item:nth-child(12),
.table-item:nth-child(14) {
  background: #f8fbff;
}
.table-item p {
  flex: 1;
  text-align: center;
  font-size: rem(24);
}
.table-item p:first-child {
  text-align: left;
  min-width: rem(240);
}
.table-item p:last-child {
  color: #1890ff;
}
.table-item:first-child,
.table-item:nth-child(9),
.table-item:nth-child(13) {
  p:last-child {
    color: #999999;
  }
}
.table-item:first-child,
.table-item:nth-child(9),
.table-item:nth-child(13) {
  background: #f2f2f7;
  color: #999999;
}
.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 rem(45);
}
.mask-content {
  background: white;
  width: rem(660);
  box-sizing: border-box;
  border-radius: rem(10);
  text-align: center;
}
.confirm-header {
  font-size: rem(34);
  padding: rem(30) 0 rem(15);
  font-weight: 800;
}
.confirm-bd {
  text-align: left;
  color: #666;
  font-size: rem(32);
  line-height: rem(48);
  padding: rem(60) rem(80);
}
.confirm-footer {
  margin: rem(25) - (rem(15)) - (rem(15));
  /*width: rem(580);*/
  height: rem(108);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: rem(1) solid #e0e0e0;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-size: rem(32);
}
.confirm-ok {
  color: #12b7f5;
  height: rem(108);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: rem(32);
  border-left: rem(2) solid #eee;
  button {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vip/vipTest.vue